/// <reference path="../react-table-config.d.ts" />
import { CSSProperties } from '@material-ui/core/styles/withStyles'
import React, { ReactNode } from 'react'
import { Row } from 'react-table'
import TableChildrenBody from './TableChildrenBody'
import TableRow from './TableRow'

export interface TableBodyProps<TData extends Object> {
    cellCssOverride?: CSSProperties
    checkboxColumnWidth: number
    prepareRow: (row: Row<TData>) => void
    rows: Row<TData>[]
    paddingTop?: number
    paddingBottom?: number
    rowVirtualizer?: any
    LoadNextComponent?: ReactNode
    SkeletonComponent?: ReactNode
    enablePagination?: boolean
}

const TableBody = <TData extends Object>({
    cellCssOverride,
    checkboxColumnWidth,
    prepareRow,
    rows,
    paddingTop = 0,
    paddingBottom = 0,
    rowVirtualizer,
    LoadNextComponent,
    SkeletonComponent,
    enablePagination,
}: TableBodyProps<TData>) => {
    const parentRows = rows.filter((row) => row.isGrouped)
    const paginationRows = 100;

    return (
        <div>
            <div className="tr" style={{ padding: 0, opacity: 0 }}>
                <div
                    className="td"
                    style={{
                        height: `${paddingTop}px`,
                        padding: 0,
                    }}
                />
            </div>
            {enablePagination
                ? parentRows.map((row: Row<TData>) => {
                      prepareRow(row)
                      const childRows: Row<TData>[] = []

                      if (row.isExpanded) {
                        childRows.push(...row.leafRows)
                      }

                      return (
                          <>
                              <TableRow
                                  cellCssOverride={cellCssOverride}
                                  checkboxColumnWidth={checkboxColumnWidth}
                                  row={row}
                              />
                              {row.isExpanded && (
                                  <TableChildrenBody
                                      rows={childRows}
                                      isPaginationRequired={
                                          childRows.length > paginationRows
                                      }
                                      prepareRow={prepareRow}
                                      checkboxColumnWidth={checkboxColumnWidth}
                                      cellCssOverride={cellCssOverride}
                                      LoadNextComponent={LoadNextComponent}
                                      SkeletonComponent={SkeletonComponent}
                                      childTablePageSize={paginationRows}
                                  />
                              )}
                          </>
                      )
                  })
                : rowVirtualizer?.virtualItems.map((virtualRow: any) => {
                      const row = rows[virtualRow.index]
                      prepareRow(row)

                      return (
                          <TableRow
                              {...{
                                  cellCssOverride,
                                  checkboxColumnWidth,
                                  row,
                              }}
                          />
                      )
                  })}
            {!enablePagination && <div className="tr" style={{ padding: 0, opacity: 0 }}>
                <div
                    className="td"
                    style={{
                        height: `${paddingBottom}px`,
                        padding: 0,
                    }}
                />
            </div>}
            {!!LoadNextComponent ? LoadNextComponent : <></>}
            {!!SkeletonComponent ? SkeletonComponent : <></>}
        </div>
    )
}

export default TableBody
